import React from "react";
import { YouTube, LinkedIn } from "@mui/icons-material";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/X";
import tvSvg from "../assets/images/RETVlogo.svg";
import googleSvg from "../assets/images/RELogoSocial.svg";

// Social Icons List
export const ReSocialIconsList = [
  {
    icon: (
      <LinkedIn
        fontSize="large"
        sx={{
          color: "#FFFFFF",
          "&:hover": { color: "#0077B5" },
          transition: "color 0.3s ease",
        }}
      />
    ),
    label: "LinkedIn",
  },
  {
    icon: (
      <img
        src={tvSvg}
        alt="TV"
        style={{
          width: 32,
          height: 32,

          transition: "filter 0.3s ease",
        }}
        onMouseOver={(e) =>
          (e.currentTarget.style.filter =
            "invert(18%) sepia(96%) saturate(7486%) hue-rotate(357deg) brightness(103%) contrast(125%)")
        }
        onMouseOut={(e) => (e.currentTarget.style.filter = "none")}
      />
    ),
    label: "TV",
  },
  {
    icon: (
      <InstagramIcon
        fontSize="large"
        sx={{
          color: "#FFFFFF",
          "&:hover": { color: "#962FBF" },
          transition: "color 0.3s ease",
        }}
      />
    ),
    label: "Instagram",
  },
  {
    icon: (
      <YouTube
        fontSize="large"
        sx={{
          color: "#FFFFFF",
          "&:hover": { color: "#FF0000" },
          transition: "color 0.3s ease",
        }}
      />
    ),
    label: "YouTube",
  },

  {
    icon: (
      <TwitterIcon
        fontSize="large"
        sx={{
          color: "#FFFFFF",
          "&:hover": { color: "#000000" },
          transition: "color 0.3s ease",
        }}
      />
    ),
    label: "Twitter",
  },
  {
    icon: (
      <img
        src={googleSvg}
        alt="Google"
        style={{
          width: 36,
          height: 36,
          filter: "invert(1)",
          transition: "filter 0.3s ease",
        }}
        onMouseOver={(e) =>
          (e.currentTarget.style.filter =
            "invert(42%) sepia(87%) saturate(1497%) hue-rotate(346deg) brightness(94%) contrast(95%)")
        }
        onMouseOut={(e) => (e.currentTarget.style.filter = "invert(1)")}
      />
    ),
    label: "Google+",
  },
];

// Function to Get Social Media Icon
export const getSocialIcon = (title: string) => {
  return (
    ReSocialIconsList.find(
      (social) => social.label.toLowerCase() === title.toLowerCase()
    )?.icon || null
  );
};
